<template>
  <!-- 联系人列表 -->
  <ul>
    <li class="d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in items" :key="item.teamId" @click="!showSelectedStatus && itemClickEvent(item)">     
    <div class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover p-relative"  v-if="((!value||(value&&item.name&&item.name.includes(value)))&&!item.name.includes('圆捷群'))">
      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="item.serverCustom && item.avatar !== 'N'"  style="text-align: center;" >
        <img v-if="item.avatar" :src="item.avatar" style="width:40px;height:40px;"/>
        <img v-else src="@/assets/images/im/zhuanShu@2x.png" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p w-64 t-a-center" v-else>
        <img src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
      </div>
      <div class="d-table-cell v-a-middle h-100-p">
        <div :style="{width:listWidth+'px'}">
          <p class="t-ellipsis l-h-1-6-em m-r-10">{{item.name}}</p>
        </div>
      </div>
        <template v-if="showSelectedStatus">
          <input class="p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p" name="Fruit" type="checkbox" :value="item.teamId" v-model="selectedSessionsID" @change="onSelectedSessionChange(item)"/>
          <i class="d-inline-block m-t-22" v-if="selectedSessionsID.includes(item.teamId)">
            <img src="@/assets/images/im/selectedSession@2x.png" style="width:22px;height:22px;"/>
          </i>
          <i class="d-inline-block m-t-22" v-else>
            <img src="@/assets/images/im/unSelectedSession@2x.png" style="width:22px;height:22px;"/>
          </i>
        </template>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: Number,
      default: 185
    },
    type:{
      type:String
    }
  },
  data: function () {
    return {
      listWidth: 185,
      listgroup: [],
      selectedSessionsID: [],
      showSelectedStatus: this.$attrs.showSelectedStatus || false
    };
  },
  created: function () {
  },
  mounted: function () {
    // var that = this;
    // this.$nextTick(function () {
    //   that.listgroup = this.items;
    // });
  },
  methods: {
    // 用户信息
    getUserRole: function (item) {
      var str = '';
      str += item.name && item.name !== '无' ? ' ' + item.name : '';
      return str;
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    // 点击联系人
    itemClickEvent: function (item) {
      document.querySelector('#imLayout').click();
      if(this.type){
        this.$emit('createSession', item);
      }else{
        this.$emit('createSessionGroup', item);
      }
      this.bus.$emit("selectNewsTab");
    },
    onSelectedSessionChange(item){
      if(this.selectedSessionsID.includes(item.teamId)){
        this.$emit('createSession', item);
      }else{
        this.$emit('delSelectedSession', {
          delItem: item,
          keyName: "teamId"
        });
      }
    }
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    },
    items: function (val) {
      this.listgroup = val;
    },
    "$attrs.reverseDelSession"(newVal){
      if(Object.keys(newVal).length > 0){
        //点击右侧的删除，反向删除左侧选中的列表
        let index = this.selectedSessionsID.findIndex(item=>{
          return item == newVal.teamId
        })
        this.$delete(this.selectedSessionsID,index);
      }
    },
    "$attrs.visible"(newVal){
      if(!newVal){
        this.selectedSessionsID = [];
      }
    },
    
  }
}
</script>
